module.exports = __webpack_public_path__ + "static/media/AV.89536a99.pdf";